module.exports = __webpack_public_path__ + "static/img/index-background.1915d303.png";